export const ROLES = {
  ADMIN: 'admin',
  VUZ_SPRAVCE: 'vuz_spravce',
  VUZ_READ: 'vuz_read',
  VUZ_EDITOR: 'vuz_edit',
}
